var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as z from 'zod';
export function createEventSchema(shape, endpoint) {
    return z.object(shape).transform(function (data) { return (__assign({ endpoint: endpoint }, data)); });
}
